const ServiceCard = ({ data }) => {
  return (
    <div className='serviceCard'>
      <div className='bg-white rounded-md border-2 border-transparent hover:border-eventLightYellow hover:transition-all hover: ease-in-out shadow-xl flex flex-col justify-center items-center py-8 lg:py-12 px-3'>
        <img className='rounded-full' src={data?.image} alt='logo' />
        <h2 className='capitalize text-xl font-bold py-4'>{data?.title}</h2>
        <p className='text-center text-sm text-eventGray'>{data?.desc}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
